import { Button, Container, Dialog, IconButton, Paper, Stack, Typography ,Box} from '@mui/material';
import { FormProvider, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const TABLE_HEADER = [
  { header: 'Role', accessor: 'role' },
  { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } },
  { header: 'Created At', accessor: 'createdAt' }
];

const initialRoleDataObj = {
  data: [],
  loading: false
};

export const Role = () => {
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [roleDataObj, setRoleDataObj] = useState(initialRoleDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        role: Yup.string().required(' ')
      })
    ),
    defaultValues: {},
    mode: 'all'
  });
  const { handleSubmit, reset, setValue } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('role', selectedRecord.role);
    } else {
      reset();
    }
  }, [selectedRecord, setValue, reset]);

  const formSubmitHandler = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/role-master-update' : '/role-master-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: formValues
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Role master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Role master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/role-master-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Role master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Role master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setRoleDataObj({ loading: true });
    const response = await request('/role-master-list', { method: 'GET' });
    if (response?.success) {
      setRoleDataObj({ loading: false, data: response.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setRoleDataObj({ loading: false });
    }
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container sx={{
          mt: 1,
          border: '0px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
          width: '100%',
          maxWidth: 'none',
          minWidth: "100%",
          boxSizing: 'border-box',

        }}>
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmitHandler)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{ pb: 0.5, mb: 3, borderBottom: '1px solid', borderColor: 'grey.300' }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Role Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </Button>
                <Button
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </Button>
                <Button
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </Button>
                <Button variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Stack spacing={2}>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Role</Typography>
                <TextField
                  name="role"
                  sx={{ flex: 1 }}
                  inputProps={{ sx: { fontSize: '1.2rem' } }}
                  placeholder="Enter Role"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Role Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={roleDataObj.data || []}
          loading={roleDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
